import { connect } from 'react-redux';
import CustomerDetailForm from '../components/CustomerDetailForm';
import { setAddressList } from '../actions/addressActions';
import { getMemberType } from '../selectors/converterSelector';

const mapStateToProps = function(store) {
    return {
        globalConfig: store.globalConfig.data,
        memberType: getMemberType(store),
        addressList: store.address.list,
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        setAddressList: (list) => dispatch(setAddressList(list)),
    };
};
const ConnectedCustomerDetailForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerDetailForm);

export default ConnectedCustomerDetailForm;
